import {fetchHydra as baseFetchHydra, hydraDataProvider as baseHydraDataProvider} from "@api-platform/admin";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { parseHydraDocumentation } from "@api-platform/api-doc-parser";

const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;
//02e15d38da58350758bed97514f9e695
const fetchHeaders = {
    'X-AUTH-TOKEN': `${window.localStorage.getItem('token')}`,
};
let fetchHydra = (url, options = {}) => baseFetchHydra(url, {
    ...options,
    headers: new Headers(fetchHeaders),
});
const apiDocumentationParser = entrypoint => parseHydraDocumentation(entrypoint, { headers: new Headers(fetchHeaders) })
    .then(
        ({ api }) => ({ api }),
        (result) => {
            switch (result.status) {
                case 401:
                    return Promise.resolve({
                        api: result.api,
                        customRoutes: [
                            <Route path="/" render={() => {
                                return window.localStorage.getItem("token") ? window.location.reload() : <Redirect to="/login" />
                            }} />
                        ],
                    });

                default:
                    return Promise.reject(result);
            }
        },
    );
const NetAndersDataProvider = baseHydraDataProvider(entrypoint, fetchHydra, apiDocumentationParser);


export default NetAndersDataProvider;